import React, { useState } from 'react';

import {
    Card,
    CardHeader,
    CardBody,
    IconButton,
    Button,
    Tooltip,
    ListItem,
    ListItemPrefix,
    Typography,
    Progress,

} from "@material-tailwind/react";
import {
    PencilSquareIcon,
    UserIcon,
    FolderPlusIcon,
    XMarkIcon
} from "@heroicons/react/24/outline";



import { getCrops } from './AdminTools';
import CropCard from './CropCard';

export default function CropTableCard(props) {

    const [crops, setCrops] = useState(JSON.parse(localStorage.getItem("crops")) || []);
    const [session, setSession] = useState(localStorage.getItem("session") || null);
    const [failed, setFailed] = useState(false);
    const [message, setMessage] = useState('');
    const [cropname, setCropname] = useState("");
    const [cropid, setCropid] = useState(0);
    
    const [showCropCard, setShowCropCard] = useState(false);

    React.useEffect(() => {
        
    }, []);




    function cancelClose() {
        props.close();
    }

    function compareCrops(a, b) {
        if (a.cropname < b.cropname) {
            return -1;
        }
        if (a.cropname > b.cropname) {
            return 1;
        }
        return 0;
    }


    const handleNewParameter = (e) => {
        const cropid = e.currentTarget.getAttribute("data-id");
        setCropid(0);
        setCropname("");
        setShowCropCard(true);
    };

    const handleEditParameter = (e) => {
        const cropid = e.currentTarget.getAttribute("data-id");
        setCropid(cropid);
        console.log("cropid " + cropid)
        var crop=crops.filter(c => c.id == cropid);
        if (crop.length>0) setCropname(crop[0].cropname);
        setShowCropCard(true);
    };


    function closeCropCard()
    {
        getCrops(session,setCrops); ////<-----
        setShowCropCard(false);
    }

    function sortCrops(data)
    {
        data.sort(compareCrops);
        setCrops(data);
    }

    return (
        <div className='fixed w-full h-full top-0 left-0 items-center justify-center m-auto z-[20] flex place-content-center bg-black/50 '>
            <Card color="white" className="w-[28rem] max-w-[90vw] mx-auto rounded-lg shadow-lg max-h-[90vh] " shadow={true}>

                <IconButton variant='text' className='flex self-align-right mr-1 ml-auto mt-1' color="blue-gray" data-refresh={false} onClick={cancelClose}>
                    <XMarkIcon className='w-5 h-5' />
                </IconButton>

                    <div className="mb-0 flex flex-col justify-center items-center ">
                        <div className="flex w-full mb-4 justify center items-center">
                            <Typography variant="h6" color="blue-gray" className="mx-auto">
                                Dostępne płodozmiany
                            </Typography>
                        </div>
                        <div className="flex w-full mb-2">
                            <Button className="mx-auto flex items-center" size="sm" color="green" data-id={0} onClick={handleNewParameter}>
                                <FolderPlusIcon strokeWidth={2} className="h-4 w-4 mr-2" />Dodaj nowy
                            </Button>
                        </div>

                    </div>
                    <div className='flex max-h-[80vh] overflow-y-auto'>
                    <table className="w-full table-auto text-left ">
                        <thead>
                            <tr>
                                <th key="id" className="border border-blue-gray-100 bg-blue-gray-50/50 p-2">
                                    <div className='flex flex-col items-center'>
                                        <Typography variant="h6" color="blue-gray" className="font-normal opacity-70 md:text-md text-xs">Id</Typography>
                                    </div>
                                </th>

                                <th key="cropname" className="border border-blue-gray-100 bg-blue-gray-50/50 p-2">
                                    <div className='flex flex-col items-center'>
                                        <Typography variant="h6" color="blue-gray" className="font-normal opacity-70 md:text-md text-xs hidden md:block">Nazwa</Typography>
                                    </div>
                                </th>

                                <th key="edit" className="border-y w-12 border-blue-gray-100 bg-blue-gray-50/50 p-2 ">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {crops && crops.map(
                                (
                                    {
                                        id,
                                        cropname,
                                    },
                                    index,
                                ) => {
                                    const isLast = index === crops.length - 1;
                                    const classes = isLast ? "border justify-center p-2" : "border justify-center p-2";

                                    return (
                                        <tr key={id} className='even:bg-blue-gray-50/50'>

                                            <td className="border justify-center p-2">
                                                    <Typography variant="small" color="blue-gray" className="flex font-normal justify-center">
                                                        {id}
                                                    </Typography>
                                            </td>

                                            <td className="border justify-center p-2">
                                                <Typography variant="small" color="blue-gray" className="flex font-normal justify-center">
                                                    {cropname}
                                                </Typography>
                                            </td>

                                            <td className="items-center justify-right flex">
                                                <Tooltip content="Edytuj parametry" >
                                                    <IconButton variant="gradient" size="sm" className="ml-auto mr-2 mt-1" data-id={id} onClick={handleEditParameter}>
                                                        <PencilSquareIcon className="h-4 w-4" />
                                                    </IconButton>
                                                </Tooltip>
                                            </td>

                                        </tr>
                                    );
                                },
                            )}
                        </tbody>
                    </table>
                </div>
            </Card>
        {showCropCard && <CropCard close={closeCropCard} crops={crops} cropid={cropid} cropname={cropname} />}                    
        </div>
    );
}

